import { CRAZY_EGG_ID } from '../const';

// HORO-10451 — CrazyEgg heatmaps / scrollmaps / session recordings.
//
// Reuses the same CrazyEgg account as astrology.com (deployed there via GTM);
// Veda has no GTM layer, so we inject the standard async snippet directly —
// consistent with how CheckoutRisk loads its third-party script.
//
// The account number splits into two 4-char halves for the script path:
//   '00549225' -> //script.crazyegg.com/pages/scripts/0054/9225.js
// The trailing timestamp (bucketed hourly) is CrazyEgg's own cache-buster.
class CrazyEgg {
    constructor() {
        this.script = null;
    }

    init() {
        // No account configured (dev/staging) or already loaded — no-op.
        if (!CRAZY_EGG_ID || this.script) return;

        const id = String(CRAZY_EGG_ID).padStart(8, '0');
        const head = document.getElementsByTagName('HEAD')[0];
        const link = document.createElement('script');
        link.type = 'text/javascript';
        link.async = true;
        link.src = `//script.crazyegg.com/pages/scripts/${id.slice(0, 4)}/${id.slice(4)}.js?${Math.floor(Date.now() / 3600000)}`;
        head.appendChild(link);
        this.script = link;
    }
}

export default new CrazyEgg();
